import React from "react";
import { cn } from "utils";
import NextImage from "./NextImage";
interface TokenIconProps {
  imageUrl?: string;
  chainImageUrl?: string;
  className?: string;
  /** 主图额外样式，用于控制尺寸/边框等 */
  imageClassName?: string;
  /** 链标额外样式，用于控制尺寸/位置等 */
  chainImageClassName?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const TokenIcon: React.FC<TokenIconProps> = ({
  imageUrl,
  chainImageUrl,
  className,
  imageClassName,
  chainImageClassName,
  onClick,
}) => {
  return (
    <div
      data-openreplay-label="TokenIcon · div"
      className={cn(
        "pr-1 border border-background_white_overlay5 relative w-6",
        className,
      )}
      onClick={onClick}
    >
      {imageUrl && (
        <NextImage
          src={imageUrl}
          alt="token"
          width={24}
          height={24}
          className={cn("rounded-full min-w-6 w-6 h-6", imageClassName)}
        />
      )}
      {chainImageUrl && (
        <span
          className={cn(
            "absolute bottom-0 right-[-3px] block rounded-full w-[10px] h-[10px] bg-background_solid_primary",
            chainImageClassName,
          )}
        >
          <NextImage
            src={chainImageUrl}
            alt="chain"
            width={10}
            height={10}
            className="w-full h-full rounded-full"
          />
        </span>
      )}
    </div>
  );
};

export default TokenIcon;
